<div class="alert alert-success" role="alert" *ngIf="Idproceso !==''">
    <h4 class="alert-heading">Firma digital</h4>

    <hr>
    <p class="mb-0">la firma digital fue forma correcta</p>
</div>
<div class="alert alert-success" role="alert" *ngIf="Idproceso===''">
    <h4 class="alert-heading">No se puede procesar la solicitud.</h4>
    <hr>
    <a href="/" class="btn btn-block btn-primary">volver</a>
</div>